import axios from 'axios'

// const API_URL = process.env.VUE_APP_API_HOST || ''
const API_URL = ''

let axiosInstance = axios.create({
    baseURL: API_URL,
    headers: (() => {
        if (localStorage.getItem('auth.token')) {
            return {
                'Content-Type': 'application/json',
                'ngrok-skip-browser-warning': 'true',
                'Authorization': 'Bearer ' + localStorage.getItem('auth.token')
            }
        }
        return {
            'ngrok-skip-browser-warning': 'true',
            'Content-Type': 'application/json',
        }
    })()


})

axiosInstance.interceptors.response.use(function(response) {
    return response;
}, function(error) {
    if (error.response.data.message == 'This action is unauthorized.' && error.response.status == 403) {
        localStorage.setItem('auth.token', '');
        localStorage.setItem('auth.email', '');
        localStorage.setItem('auth.name', '');
        localStorage.setItem('auth.role', '');
        localStorage.setItem('auth.user_id', '');
        window.location.href = '/';
    }
    return Promise.reject(error);
});

export default axiosInstance
